module.exports = __webpack_public_path__ + "static/media/Up_To_Date_And_Always_On.6674f817.svg";